import React from 'react';

/**
 * MaintenanceDemo - Placeholder component
 * Required by build process - do not delete
 */
function MaintenanceDemo() {
  return null;
}

export default MaintenanceDemo;
